import { Modal, Radio, Slider, Button, Space } from "antd";
import { DownloadOutlined } from "@ant-design/icons";

export default function ExportModal({
  open,
  onCancel,
  format,
  onFormatChange,
  quality,
  onQualityChange,
  onDownload,
}) {
  return (
    <Modal
      title="Export image"
      open={open}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
    >
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <div>
          <div style={{ marginBottom: 8 }}>Format</div>
          <Radio.Group value={format} onChange={(e) => onFormatChange(e.target.value)}>
            <Radio.Button value="png">PNG</Radio.Button>
            <Radio.Button value="jpeg">JPEG</Radio.Button>
          </Radio.Group>
        </div>
        {format === "jpeg" && (
          <div>
            <div style={{ marginBottom: 8 }}>Quality</div>
            <Slider
              min={0.5}
              max={1}
              step={0.05}
              value={quality}
              onChange={onQualityChange}
            />
          </div>
        )}
        <Button
          type="primary"
          block
          size="large"
          icon={<DownloadOutlined />}
          onClick={onDownload}
        >
          Download
        </Button>
      </Space>
    </Modal>
  );
}
